import { IStatesReducer, IState } from 'models/State'
import { Action } from 'redux'
import { isType } from 'ts-action'
import { updateArray } from 'helpers/helperFunctions'
import { GetStates, StatesFetching, UpdateState } from './actions'

const initialState: IStatesReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const statesReducer = (state = initialState, action: Action): IStatesReducer => {
  if (isType(action, GetStates)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }
  if (isType(action, UpdateState)) {
    const { payload } = action
    const { data } = state
    const formattedArray = updateArray<IState>(data, payload.data)
    return {
      ...state,
      data: formattedArray,
    }
  }
  if (isType(action, StatesFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  return state
}
